import { render, staticRenderFns } from "./DefaultWidget.vue?vue&type=template&id=c556a254&"
import script from "./DefaultWidget.vue?vue&type=script&lang=js&"
export * from "./DefaultWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports